import { useState, useEffect } from 'react';
import {
	createBrowserRouter,
	createRoutesFromElements,
	Route,
	RouterProvider,
} from 'react-router-dom';

import { NotFoundPage } from './pages/NotFound.pages';
import { PositionNotFoundPage } from './pages/PositionNotFound.pages';
import { InternalServerErrorPage } from './pages/InternalServerError';
import { InactivePage } from './pages/Inactive.pages';
import { AdminLoginPage } from './pages/AdminLogin.pages';
import { CandidateLoginPage } from './pages/CandidateLogin.pages';
import { LobbyPage } from './pages/Lobby.pages';
import { InterviewRoomPage } from './pages/InterviewRoom.pages';
import { AuthProvider } from './components/AuthProvider';
import { PositionWrapper } from './components/PositionWrapper';
import { logError } from './utils/logger.utils';

export const App = () => {
	const [audioVideoStream, setAudioVideoStream] = useState<MediaStream | null>(
		null
	);
	const [screenStream, setScreenStream] = useState<MediaStream | null>(null);
	const [devices, setDevices] = useState<{
		speakerId: string | null;
		cameraId: string | null;
		microphoneId: string | null;
	} | null>(null);

	useEffect(() => {}, []);

	const handleStartAudioVideoStream = async (
		cameraId?: string,
		microphoneId?: string
	): Promise<MediaStream | null> => {
		let mediaStream: MediaStream | null = null;
		try {
			mediaStream = await navigator.mediaDevices.getUserMedia({
				video: cameraId ? { deviceId: { exact: cameraId } } : true,
				audio: microphoneId ? { deviceId: { exact: microphoneId } } : true,
			});

			setAudioVideoStream(mediaStream);

			// Detect if camera/microphone is stopped
			mediaStream.getTracks().forEach((track) => {
				track.onended = () => {
					setAudioVideoStream(null);
				};
			});

			return mediaStream;
		} catch (err) {
			logError(err);
			mediaStream?.getTracks().forEach((track) => track.stop());

			setAudioVideoStream(null);

			return null;
		}
	};

	const handleStopAudioVideoStream = (): boolean => {
		try {
			audioVideoStream?.getTracks().forEach((track) => track?.stop());
			setAudioVideoStream(null);

			return true;
		} catch (error) {
			logError(error);
			return false;
		}
	};

	// 	return (
	// 		<>
	// 			<div className="w-full min-h-screen bg-blue-50">
	// 				<Routes>
	// 					<Route
	// 						path="/"
	// 						element={
	// 							<LoginPage
	// 								setIsUserLoggedIn={setIsUserLoggedIn}
	// 								setUserDetails={setUserDetails}
	// 							/>
	// 						}
	// 					/>
	// 					<Route
	// 						path="/lobby"
	// 						element={
	// 							<LobbyPage
	// 								startAudioVideoStream={handleStartAudioVideoStream}
	// 								stopAudioVideoStream={handleStopAudioVideoStream}
	// 								audioVideoStream={audioVideoStream}
	// 								setDevices={setDevices}
	// 								setScreenStream={setScreenStream}
	// 							/>
	// 						}
	// 					/>
	// 					<Route
	// 						path="/interview"
	// 						element={
	// 							<InterviewRoomPage
	// 								devices={devices}
	// 								handleStopAudioVideoStream={handleStopAudioVideoStream}
	// 								audioVideoStream={audioVideoStream}
	// 								screenStream={screenStream}
	// 								userDetails={userDetails}
	// 								setScreenStream={setScreenStream}
	// 							/>
	// 						}
	// 					/>
	// 					<Route path="*" element={<NotFoundPage />} />
	// 				</Routes>

	// 				<Toaster position="top-center" />
	// 			</div>
	// 		</>
	// 	);
	// };

	const router = createBrowserRouter(
		createRoutesFromElements(
			<>
				{/* Position-based routes */}
				<Route
					path="/:positionId/*"
					element={
						<AuthProvider>
							<PositionWrapper />
						</AuthProvider>
					}
				>
					<Route path="login/admin" element={<AdminLoginPage />} />
					<Route path="login/candidate" element={<CandidateLoginPage />} />
					<Route
						path="lobby"
						element={
							<LobbyPage
								startAudioVideoStream={handleStartAudioVideoStream}
								stopAudioVideoStream={handleStopAudioVideoStream}
								audioVideoStream={audioVideoStream}
								setDevices={setDevices}
								setScreenStream={setScreenStream}
							/>
						}
					/>
					<Route
						path="interview"
						element={
							<InterviewRoomPage
								devices={devices}
								handleStopAudioVideoStream={handleStopAudioVideoStream}
								audioVideoStream={audioVideoStream}
								screenStream={screenStream}
								setScreenStream={setScreenStream}
							/>
						}
					/>
					<Route path="500" element={<InternalServerErrorPage />} />
					<Route path="inactive" element={<InactivePage />} />
					<Route path="not-found" element={<PositionNotFoundPage />} />
				</Route>

				{/* Global routes */}
				<Route path="/404" element={<NotFoundPage />} />
				<Route path="*" element={<NotFoundPage />} />
			</>
		)
	);

	return <RouterProvider router={router} />;
};
